import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import {
  Grid, FormControl, FormLabel, FormGroup, Checkbox,
} from '@mui/material';
import 'react-day-picker/lib/style.css';
import DateRangeFilterSingle from './date-range-filter-single';

class DateRangeFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectorChecked: !isEmpty(props.filterList[props.index]),
      showSelectors: !isEmpty(props.filterList[props.index]),
    };
  }

  static getDerivedStateFromProps(props) {
    const { filterList, index } = props;
    const newState = {};
    if (!isEmpty(filterList[index])) {
      newState.selectorChecked = true;
    }
    return newState;
  }

  render() {
    const {
      filterList,
      onChange,
      index,
      column,
      name,
    } = this.props;
    const { showSelectors, selectorChecked } = this.state;

    return (
      <FormControl>
        <Grid container>
          <Grid item xs={12}>
            <FormLabel>{name}</FormLabel>
            <Checkbox
              checked={selectorChecked}
              onChange={() => this.setState({ showSelectors: !showSelectors })}
            />
          </Grid>
        </Grid>
        <FormGroup>
          {showSelectors && (
            <Grid container>
              <Grid item xs={4}>
                <DateRangeFilterSingle
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="After"
                  filterArrayIndex={0}
                />
              </Grid>
              <Grid item xs={4}>
                <DateRangeFilterSingle
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Before"
                  filterArrayIndex={1}
                />
              </Grid>
            </Grid>
          )}
        </FormGroup>
      </FormControl>
    );
  }
}

DateRangeFilter.propTypes = {
  filterList: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.any)),
  onChange: PropTypes.func,
  index: PropTypes.number,
  name: PropTypes.string,
  column: PropTypes.objectOf(PropTypes.any),
};

DateRangeFilter.defaultProps = {
  filterList: [],
  onChange: () => {},
  index: 0,
  column: {},
  name: '',
};

export default DateRangeFilter;
